import React, { Component } from "react";
import { Link } from "react-router-dom";

class Transparencia extends Component {
  componentDidMount() {
    if (typeof window.startx === "function") {
      window.startx();
    }
  }

  render() {
    return (
      <div id="main" className="wrapper">
        <div className="container">

          <header className="major">
            <h2>Transparencia</h2>
          </header>

          {/* FILA 1 */}
          <div className="row">
            <div className="col-md-4">
              <Link to="/rubros">Art. 69 Ley de Transparencia (48 Rubros)</Link>
            </div>

            <div className="col-md-4">
              <Link className="ld" to="/transparencia/contabilidad">
                Contabilidad Gubernamental
              </Link>
            </div>

            <div className="col-md-4">
              <Link className="ld" to="/transparencia/licitaciones">
                Licitaciones
              </Link>
            </div>
          </div>

          {/* FILA 2 */}
          <div className="row">
            <div className="col-md-4">
              <Link to="/rubro70">Art. 70 Ley de Transparencia</Link>
            </div>

            <div className="col-md-4">
              <Link to="/transparencia/leygcg">
                Ley General de Contabilidad Gubernamental
              </Link>
            </div>

            <div className="col-md-4">
               <Link to="/transparencia/Archivos">
                Programas Anuales de Desarrollo Archivístico
              </Link>
            </div>
          </div>

          {/* FILA 3 */}
          <div className="row">
            <div className="col-md-4">
              <a href="/PDF/poa2021IP.pdf" target="_blank" rel="noopener noreferrer">
                Presupuesto 2021 Ingresos Propios
              </a>
            </div>

            <div className="col-md-4">
              <a href="/PDF/poa2021RF.pdf" target="_blank" rel="noopener noreferrer">
                Presupuesto 2021 Recurso Fiscal
              </a>
            </div>

            <div className="col-md-4">
              <a href="/PDF/manual-de-procedimientos-agosto2022.pdf" target="_blank" rel="noopener noreferrer">
                Manual de Procedimientos
              </a>
            </div>
          </div>

          {/* FILA 4 */}
          <div className="row">
            <div className="col-md-4">
              <a
                href="http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Acta_Presupuesto_2023.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Acta de Proyecto del Presupuesto Anual 2023
              </a>
            </div>

            <div className="col-md-4">
              <a href="/PDF/PED_2022_2028.pdf" target="_blank" rel="noopener noreferrer">
                Plan Estatal de Desarrollo 2022-2028
              </a>
            </div>
            <div className="col-md-4">
              <a href="/PDF/PID_2022_2028.pdf" target="_blank" rel="noopener noreferrer">
                Programa Institucional de Desarrollo 2023-2028
              </a>
            </div>
          </div>
          {/* FILA 5 */}
          <div className="row">
            <div className="col-md-4">
              <a
                href="http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir2/PAAAS/PAAAS_2025.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Programa Anual de Adquisiciones 2025
              </a>
            </div>

             <div className="col-md-4">
              <a
                href="http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir2/PAAAS/PAAAS_2026.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Programa Anual de Adquisiciones 2026
              </a>
            </div>
            <div className="col-md-4">
               <Link to="/adecuaciones2025">
                Adecuaciones PAAS 2025
              </Link>
            </div>
            </div>
            {/* FILA 6 */}
            <div className="row">

            <div className="col-md-4">
              <Link to="/transparencia/designacion">
              Protocolo Cero
              </Link>
            </div>
            </div>
        </div>
      </div>
    );
  }
}

export default Transparencia;